/**
 * The rule for a person's first and last name (#253): a letter first, then letters, spaces,
 * apostrophes and hyphens ("Mary Ann", "O'Neil", "Smith-Jones"). The API's input models apply
 * the same expression, so a name the form accepts is never refused on save.
 */

/**
 * For an input's `pattern`. The browser anchors it and compiles it with the `v` flag, where a
 * hyphen inside a class must be escaped.
 */
export const NAME_PATTERN = "[A-Za-z][A-Za-z '\\-]*";

const NAME_REGEX = new RegExp(`^${NAME_PATTERN}$`);

/** True when `name` follows the rule. An empty or missing name is not valid. */
export const isValidName = (name) => NAME_REGEX.test(String(name ?? ""));

/** The message under an invalid name field, e.g. nameError("last name"). */
export const nameError = (field) =>
  `Please enter a valid ${field} (letters, spaces, apostrophes and hyphens only).`;
